import { render, staticRenderFns } from "./info-dialog.vue?vue&type=template&id=1c985394&"
import script from "./info-dialog.vue?vue&type=script&lang=ts&"
export * from "./info-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./info-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports